

import React, { useState, useEffect, useRef } from 'react';
// import DesignerTab from './DesignerTab';
import DesignerFlow from './DesignerFlow';





  const Designer = () => {
  
    return (

      <div>

        <DesignerFlow title="Main"/>


      </div>
    );


  };

  
  export default Designer;